import React, { useState, useEffect } from "react";
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import SwalMessage from "../_Components/SwalMessage";
import TextField from "@mui/material/TextField";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import ApiAmusementPackage from "../../../core/api/api.amusementPackage";
import { NumericFormat } from "react-number-format";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ShamsiDatePicker from "../_Components/ShamsiDatePicker";
import { tools } from "../../../core/utils/tools";
import { DateObject } from "react-multi-date-picker";

const materialUITextFieldProps = {
  style: {
    width: "100%",
    marginTop: "15px",
  },
};

export const AddEditePackageNameModal = ({ createPackageModal, setCreatePackageModal, selectedPackageId }) => {
  const [modalTitle, setModalTitle] = useState("ایجاد پکیج تفریحات");
  const {
    handleSubmit,
    control,
    formState: { isSubmitting, errors },
    setValue,
    getValues,
  } = useForm({
    defaultValues: { id: selectedPackageId },
  });
  const handleClose = () => {
    setCreatePackageModal(false);
  };
  useEffect(() => {
    (async () => {
      try {
        if (selectedPackageId != 0) {
          // دریافت اطلاعات پکیج جهت ویرایش
          setModalTitle("ویرایش پکیج تفریحات");
          let response = await ApiAmusementPackage.getAmusementPackageById(selectedPackageId);
          if (response) {
            setValue("startDate", response.startDate);
            setValue("title", response.title);

            setValue("price", response.price);
            setValue("originalPrice", response.originalPrice);
            setValue("isActive", response.isActive);
            setValue("description", response.description);
            const startDate = response.startDate?.split("T")[0];
            const endDate = response.endDate?.split("T")[0];
            setValue("startDate", startDate);
            setValue("endDate", endDate);
          }
        }
      } catch (error) {
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    try {
      if (data.startDate !== null && typeof data.startDate === "object") {
        data.startDate = tools.DateFormat(data.startDate);
      }
      if (data.endDate !== null && typeof data.endDate === "object") {
        data.endDate = tools.DateFormat(data.endDate);
      }
      data.price = _.isString(data.price) ? +data.price.replaceAll(",", "") : +data.price;
      data.originalPrice = _.isString(data.originalPrice)
        ? +data.originalPrice.replaceAll(",", "")
        : +data.originalPrice;

      let response = await ApiAmusementPackage.createEditAmusementPackage(data);

      if (response.succeeded == true) {
        document.getElementById("submitButton").click();
        handleClose();
      }
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
    }
  };

  return (
    <div>
      <Modal centered size="md" show={createPackageModal} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title> {modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="12">
                <Controller
                  name="title"
                  control={control}
                  rules={{ required: true }}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="نام پکیج"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                    />
                  )}
                />
                {errors.title && <span className="text-danger mt-3">لطفا عنوان را وارد نمایید</span>}
              </Col>

              <Col xs="12">
                <Controller
                  name="originalPrice"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <NumericFormat
                      customInput={TextField}
                      label="قیمت اصلی"
                      thousandSeparator=","
                      decimalScale="0"
                      onKeyDown={(e) => {
                        if (e.key === "Escape") {
                          e.stopPropagation()
                        }
                      }}
                      value={value}
                      onChange={onChange}
                      {...materialUITextFieldProps}
                      type="search"
                    />
                  )}
                />
              </Col>

              <Col xs="12">
                <Controller
                  name="price"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <NumericFormat
                      customInput={TextField}
                      label="قیمت فروش"
                      type="search"
                      thousandSeparator=","
                      decimalScale="0"
                      onKeyDown={(e) => {
                        if (e.key === "Escape") {
                          e.stopPropagation()
                        }
                      }}
                      value={value}
                      onChange={onChange}
                      {...materialUITextFieldProps}
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="startDate"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <ShamsiDatePicker
                      className="mt-5 w-full"
                      placeholder="تاریخ شروع"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="endDate"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <ShamsiDatePicker
                      className="mt-5"
                      placeholder="تاریخ پایان"
                      value={value}
                      onChange={(date) => {
                        const startDate = getValues("startDate");
                        if (!startDate) {
                          onChange(date);
                          setValue("startDate", date);
                        } else {
                          if (date?.toDate && date?.toDate()?.getTime() < new Date(startDate).getTime()) {
                            const test = new DateObject(new Date(startDate).getTime());
                            onChange(test);
                          }
                          else
                            onChange(date);
                        }
                      }}
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="description"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="توضیحات"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                    />
                  )}
                />
              </Col>

              <Col xs="12">
                <FormControlLabel
                  control={
                    <Controller
                      name="isActive"
                      control={control}
                      render={({ field: { onChange, onBlur, value = false, name, ref } }) => (
                        <Checkbox
                          onBlur={onBlur}
                          onChange={onChange}
                          checked={value}
                          inputRef={ref}
                          color="primary"
                        />
                      )}
                    />
                  }
                  label="فعال "
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
